import { render, staticRenderFns } from "./dyzArguments.vue?vue&type=template&id=eda7d120&scoped=true&"
import script from "./dyzArguments.vue?vue&type=script&lang=js&"
export * from "./dyzArguments.vue?vue&type=script&lang=js&"
import style0 from "./dyzArguments.vue?vue&type=style&index=0&id=eda7d120&lang=less&scoped=true&"
import style1 from "./dyzArguments.vue?vue&type=style&index=1&id=eda7d120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda7d120",
  null
  
)

export default component.exports